import axios from 'axios';
import { getAuthToken } from '../utils/storage';
import { API_BASE_URL } from './apiClient';

export const createTenant = async (tenantData) => {
    const token = getAuthToken();
    const response = await axios.post(`${API_BASE_URL}/tenants/create_tenant`, tenantData, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
    return response.data;
};

export const provisionTenant = async ({ name, admin_email }) => {
    const token = getAuthToken();
    const body = { admin_email };
    if (name != null && String(name).trim()) {
        body.name = String(name).trim();
    }
    const response = await axios.post(
        `${API_BASE_URL}/tenants/provision`,
        body,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    );
    return response.data;
};

export const getTenant = async (tenantId) => {
    const token = getAuthToken();
    const response = await axios.get(`${API_BASE_URL}/tenants/get_tenant/${tenantId}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
};

// export const getTenantsList = async (params = {}) => {
//     const token = getAuthToken();
//     const response = await axios.get(`${API_BASE_URL}/tenants/get-list`, {
//         params: {
//             skip: params.skip || 0,
//             limit: params.limit || 20
//         },
//         headers: {
//             Authorization: `Bearer ${token}`
//         }
//     });
//     return response.data;
// };

export const getTenantsList = async (params = {}) => {
    const token = getAuthToken();
    const response = await axios.get(`${API_BASE_URL}/tenants/get-list`, {
        params: {
            ...params,
            for_filter: params.for_filter || false,
            include_total: params.include_total || false,
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
};

export const updateTenant = async (tenantId, data) => {
    const token = getAuthToken();
    const response = await axios.patch(
        `${API_BASE_URL}/tenants/patch_tenant/${tenantId}`,
        data,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    );
    return response.data;
};

const tenantApi = {
    createTenant,
    getTenant,
    getTenantsList,
    updateTenant,
};

export default tenantApi;
